import {
  CustomerDetails,
  Pagination,
} from "../../../domain/models/customer-database/customer-details";
import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { RemoteFetchCustomers } from "../../../data/usecases/remote-fetch-customers";
import { FetchState } from "../../../domain/models/fetch-state";
import { FetchCustomers } from "../../../domain/useages/fetch-customers";
import { customerDatabaseFilters } from "../../../domain/models/customer-database/customer-database-filters";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchCustomerInterface {
  customerData: CustomerDetails[];
  fetchCustomerTableState: FetchState;
  fetchCustomerData: Function;
  filterStore: customerDatabaseFilters;
  pageData: Pagination;
  departmentCode: string;
  handleDepartmentCode: Function;
  filterSegement: string[];
  handleFilterSegement: Function;
  showSegement: boolean;
  showAddSegement: boolean;
  handleShowSegement: Function;
  handleShowAddSegement: Function;
}

const initialStates = {
  customerData: [],
  fetchCustomerTableState: FetchState.DEFAULT,
  filterStore: {
    status: "active",
    page: 1,
    download: 0,
    headquarter_ids: [],
  },
  pageData: {} as Pagination,
  departmentCode: "",
  filterSegement: [],
  showSegement: false,
  showAddSegement: false,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchCustomersSlice: StateCreator<FetchCustomerInterface> = (
  set,
  get
) => ({
  ...initialStates,
  handleDepartmentCode: (value: string) => {
    set(() => ({ departmentCode: value }));
  },
  handleShowSegement: (value: boolean) => {
    set(() => ({ showSegement: value }));
  },
  handleShowAddSegement: (value: boolean) => {
    set(() => ({ showAddSegement: value }));
  },
  handleFilterSegement: (value: string[]) => {
    set(() => ({ filterSegement: value }));
  },
  fetchCustomerData: async () => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchCustomers: FetchCustomers = new RemoteFetchCustomers(
      `${BASE_URL}${Endpoints.FETCH_CUSTOMERS}`,
      axiosHttpClient
    );

    set(() => ({ customerData: [] }));
    set(() => ({ pageData: { total: 0 } as Pagination }));
    set(() => ({ fetchCustomerTableState: FetchState.LOADING }));

    let result = await remoteFetchCustomers.fetch(get().filterStore);
    if (result.success) {
      set(() => ({ customerData: result.customers }));
      set(() => ({ pageData: result.paginated }));
      set(() => ({ fetchCustomerTableState: FetchState.SUCCESS }));
    }
  },
});
